import { Field, Float, ObjectType } from 'type-graphql'
import type { GetArgs } from '../repository/types'
import type { IAction } from '../action/IAction'
import type { Order } from '../order/Order'

/**
 * Footer totals for a company's statement, computed server-side over the
 * filtered order set. `arOutstanding` sums only the balances of orders whose
 * paymentStatus is receivable (Unpaid / Partially Paid).
 */
@ObjectType()
export class CompanyStatementTotals {
  @Field(() => Float)
  totalCharged: number

  @Field(() => Float)
  totalPaid: number

  @Field(() => Float)
  arOutstanding: number
}

export interface IGetCompanyStatementTotals extends IAction<CompanyStatementTotals, GetArgs<Order>> {}
